import { IAdditionalSettings } from '@shared/model/basic-data';
import { createReducer, on } from '@ngrx/store';
import { getAdditionalSettingsSuccess, updateAdditionalSettingsSuccess } from '../actions';

const initialState: IAdditionalSettings = {
  copied_project: undefined,
  ext_switch: undefined,
  finance_switch: undefined,
  name: undefined,
};

export const additionalSettingsReducer = createReducer(
  initialState,
  on(getAdditionalSettingsSuccess, (state, { additionalSettings }) => additionalSettings),
  on(updateAdditionalSettingsSuccess, (state, { data }) => ({ ...state, [data.name]: data.value })),
);
